import React from 'react';
import { AddablePanelEmptyState } from './PanelEmptyState';
import { StorylinesEmptyIllustration } from './StorylinesEmptyIllustration';

interface StorylinesEmptyStateProps {
  canEdit: boolean;
  onAdd: () => void;
}

export const StorylinesEmptyState: React.FC<StorylinesEmptyStateProps> = ({ canEdit, onAdd }) => {
  return (
    <AddablePanelEmptyState
      illustration={<StorylinesEmptyIllustration />}
      titleKey="storylines_empty_title"
      descriptionKey="storylines_empty_description"
      addLabelKey="add_storyline"
      canEdit={canEdit}
      onAdd={onAdd}
    />
  );
};
